import { useQuery } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_ACCOUNT_AVAILABLE_TEAMS = ['account-available-teams'] as const;

export function useAvailableTeams() {
  const { accountApi } = useAccountApi();

  return useQuery({
    queryKey: QK_ACCOUNT_AVAILABLE_TEAMS,
    queryFn: () => accountApi.getAvailableTeams(),
  });
}
